export default __webpack_public_path__ + "static/media/slider.6e41a9f3.png";